import React from 'react';
import { Instagram, Linkedin, Facebook, Mail, Phone } from 'lucide-react';
import { brandAssets, contactInfo } from '../utils/mockData';

export const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#59642C] text-white">
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <img src={brandAssets.logo.circular} alt="Balanced Bites Cafe" className="h-20 w-20" />
            <p className="text-white/80 leading-relaxed">
              A new generation corporate cafe designed for modern workplaces.
            </p>
            <p className="text-2xl font-bold text-[#FE9E1C] italic">
              #IDeserveit.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('menu')}
                  className="text-white/80 hover:text-[#FE9E1C] transition-colors duration-200"
                >
                  Menu
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('chef')}
                  className="text-white/80 hover:text-[#FE9E1C] transition-colors duration-200"
                >
                  Our Chef
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('approach')}
                  className="text-white/80 hover:text-[#FE9E1C] transition-colors duration-200"
                >
                  Our Approach
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('locations')}
                  className="text-white/80 hover:text-[#FE9E1C] transition-colors duration-200"
                >
                  Locations
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('partner')}
                  className="text-white/80 hover:text-[#FE9E1C] transition-colors duration-200"
                >
                  Corporate Partnerships
                </button>
              </li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-6">About</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-white/80 hover:text-[#FE9E1C] transition-colors duration-200">
                  About BBCDi
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-[#FE9E1C] transition-colors duration-200">
                  Our Story
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-[#FE9E1C] transition-colors duration-200">
                  Kiosk Concept
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-[#FE9E1C] transition-colors duration-200">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xl font-bold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#FE9E1C]" />
                <a href={`https://wa.me/919560209663`} className="text-white/80 hover:text-[#FE9E1C] transition-colors duration-200">
                  +91 9560209663
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#FE9E1C]" />
                <a href="mailto:hello@bbc-cafe.com" className="text-white/80 hover:text-[#FE9E1C] transition-colors duration-200">
                  hello@bbc-cafe.com
                </a>
              </li>
            </ul>

            {/* Social Icons */}
            <div className="flex space-x-4 mt-6">
              <a
                href={contactInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-[#FE9E1C] rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={contactInfo.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-[#FE9E1C] rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href={contactInfo.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-[#FE9E1C] rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-white/60 text-sm">
                © 2026 Balanced Bites Cafe. All rights reserved.
              </p>
              <p className="text-white/50 text-xs mt-1">
                BBC-BALANCED BITES CAFE PRIVATE LIMITED
              </p>
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-white/60 hover:text-[#FE9E1C] transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-white/60 hover:text-[#FE9E1C] transition-colors duration-200">
                Terms of Service
              </a>
              <a href="#" className="text-white/60 hover:text-[#FE9E1C] transition-colors duration-200">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
